import { Row, Col } from 'react-bootstrap';

const Footer = ({currentUser}) => {
    
  return (
    <>
     <Row>
            <Col>       
           <hr></hr>
           <h6><b>{currentUser.TenantName} අසපුව</b> {currentUser.TenantAddress}  </h6>
           <hr></hr>
            </Col>
          </Row>  
    </>
  )
}

export default Footer